import { GaEventService } from '@analytics/services/ga.event.service';
import { AfterViewInit, Component, OnInit } from '@angular/core';
import { BaseComponent } from '@core/components/base/base.component';
import { ProductDetailsService } from '@product-details/services/product-details.service';
import { UrlService } from '@shared/services/url.service';
import { ViewOffersService } from '@view-offers/services/view-offers.service';

@Component({
  selector: 'app-additional-services-container',
  templateUrl: './additional-services-container.component.html',
  styleUrls: ['./additional-services-container.component.scss'],
})
export class AdditionalServicesContainerComponent
  extends BaseComponent
  implements OnInit, AfterViewInit
{
  constructor(
    public readonly viewOffersService: ViewOffersService,
    public readonly productDetailsService: ProductDetailsService,
    public readonly gaEventService: GaEventService,
    private previousUrlService: UrlService
  ) {
    super();
  }

  offers$ = this.viewOffersService.offers$;
  selected$ = this.productDetailsService.selected$;
  offerReference$ = this.viewOffersService.offerReference$;
  previousUrl$ = this.previousUrlService.previousUrl$;

  ngOnInit() {
    this.gaEventService.AdditionalServicesPageLoad();
  }

  ngAfterViewInit(): void {
    this.viewOffersService.scrollIntoView('header', 'smooth');
  }
}
